module.exports = __webpack_public_path__ + "static/oculus_isv_partner-4494d5c278f3666f35288dd81b765c58.svg";